// extracted by mini-css-extract-plugin
export default {"container":"PublicTopicPosts-module__container--h1YyZ","animatedBackground":"PublicTopicPosts-module__animatedBackground--Xu8Wq"};